import { type ReactNode } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { TeamReportPage } from '../../features/team-reports/components/team-report-page';

/**
 * `?tab=people` — tab là thứ người ta gửi cho nhau ("xem phần theo người"),
 * nên nó ở URL. Enum chuỗi là đúng ở đây: `JSON.parse('people')` ném, nên giá
 * trị tới schema nguyên là chuỗi (bẫy APM-903b chỉ áp cho thứ `JSON.parse` đọc
 * được). `.catch()` để link gõ sai rơi về tab mặc định thay vì trang trắng.
 */
export const TeamReportSearch = z.object({
  tab: z.enum(['projects', 'people']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/team-reports/$reportId')({
  validateSearch: TeamReportSearch,
  component: TeamReportRoute,
});

/** Một báo cáo — thân trang ở `TeamReportPage` (⚠️ không nhận `asOf`, xem đó). */
function TeamReportRoute(): ReactNode {
  const { reportId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <TeamReportPage
      reportId={reportId}
      tab={search.tab}
      onTabChange={(tab) =>
        void navigate({ search: { tab: tab === 'projects' ? undefined : tab } })
      }
    />
  );
}
